module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "smart-form",
    attrs: {
      "id": "main-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('section', [_c('label', {
    staticClass: "label"
  }, [_vm._v("Imagem")]), _vm._v(" "), _c('div', {
    staticClass: "input input-file"
  }, [_c('span', {
    staticClass: "button"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "file",
      "name": "file"
    },
    on: {
      "change": function($event) {
        return _vm.appendMedia($event)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Pesquisar anexos neste computador\n      ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Clique em \"Pesquisar Anexo\" para adicionar novos anexos",
      "readonly": ""
    },
    domProps: {
      "value": _vm.selectImageName
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "superbox"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImage),
      expression: "showImage"
    }],
    staticClass: "superbox-show",
    staticStyle: {
      "display": "block",
      "max-height": "350px"
    }
  }, [_c('img', {
    staticClass: "superbox-current-img",
    staticStyle: {
      "opacity": "1"
    },
    attrs: {
      "src": _vm.currentImage.image,
      "height": "250px"
    }
  }), _vm._v(" "), _c('span', [_c('p', [_c('a', {
    staticClass: "btn btn-danger btn-sm",
    on: {
      "click": _vm.deleteImage
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" Excluir")])])]), _vm._v(" "), _c('div', {
    staticClass: "superbox-close txt-color-white",
    on: {
      "click": function($event) {
        _vm.currentImage = {}
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times fa-lg"
  })])]), _vm._v(" "), _vm._l((_vm.imageList), function(image) {
    return _c('div', {
      staticClass: "superbox-list"
    }, [_c('div', {
      staticClass: "text-center"
    }, [_c('i', {
      class: 'fa text-primary fa-3x fa-' + _vm.getExtension(image.title)
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
      ref: 'item-' + image.id,
      refInFor: true,
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.download(image)
        }
      }
    }, [_vm._v(_vm._s(image.title))]), _c('br'), _vm._v(" "), _c('a', {
      staticClass: "btn btn-danger",
      staticStyle: {
        "margin-top": "5px",
        "padding": "2px"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteImage(image.id_key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Excluir\n              ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "superbox-float"
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b7fadd7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resources/VehicleEntry/Edit/AttachmentForm.vue
// module id = 1043
// module chunks = 1